import { Layout } from "antd";

const { Footer } = Layout;

const FooterEgresados = () => {
    return (
        <Footer style={{ textAlign: "center" }}>
            <b> Copyright  ©{new Date().getFullYear()} CONALEP Estado de México. </b> Todos los derechos son reservados.
        </Footer>
    );
}
export default FooterEgresados;